import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../../Common/Icon'

const Submit = (props) => {
  let { href = '#', text = 'Link' } = props.config

  return (
    <div className="field">
      <a
        className={`link link--decoration-on-hover`}
        href={href}
        target="_blank"
        rel="noopener"
      >
        {text}
        <Icon className="btn__icon btn__icon--right" iconName="arrow-right" />
      </a>
    </div>
  )
}

Submit.propTypes = {
  config: PropTypes.object.isRequired
}

export default Submit


// WEBPACK FOOTER //
// ./src/components/FormTemplates/Content/Link.js